import { Pin, ShieldCheck, UserCircle } from "lucide-react";
import { fmtTime } from "@/lib/chat";

// Singolo messaggio: nome, sede/ruolo, ora, testo. Importanti evidenziati (pulsano finché non letti).
export default function ChatMessageItem({ msg, mine }) {
  const important = msg.is_important;
  const unreadImportant = important && !msg.read && !mine;
  const RoleIcon = msg.user_role === "operatore" ? UserCircle : ShieldCheck;
  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`chat-msg-${msg.id}`}>
      <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 text-sm shadow-sm ${
        important
          ? `border-2 border-danger bg-danger/10 text-slate-900 ${unreadImportant ? "ring-2 ring-danger/40 animate-pulse" : ""}`
          : mine ? "rounded-br-md bg-brand text-white" : "rounded-bl-md border border-border bg-white text-slate-800"}`}>
        <div className={`mb-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[11px] ${mine && !important ? "text-white/80" : "text-slate-500"}`}>
          {important && (
            <span className="inline-flex items-center gap-1 rounded-full bg-danger px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white" data-testid={`chat-important-${msg.id}`}>
              <Pin className="h-3 w-3" /> Importante{unreadImportant ? " · non letto" : ""}
            </span>
          )}
          <span className="inline-flex items-center gap-1 font-semibold">
            <RoleIcon className="h-3 w-3" /> {msg.user_name}
          </span>
          <span>· {msg.user_label}</span>
          <span className="ml-auto tabular-nums">{fmtTime(msg.created_at)}</span>
        </div>
        <div className="whitespace-pre-wrap break-words">{msg.message}</div>
      </div>
    </div>
  );
}
